<template>
  <div v-show="isVisible">
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CampaignsListWrapper",
  props: {
    productNames: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      productNameFilter: "lists/getProductNameFilter",
    }),
    isVisible() {
      return this.productNameFilter
        ? this.productNames.some(productName =>
            productName.toLowerCase().includes(this.productNameFilter)
          )
        : true;
    },
  },
};
</script>
